import participantRenderPlugin from './participant';
import hyperlinkRenderPlugin from './hyperlink';
import collapseRenderPlugin from './collapse';
import cardRenderPlugin from './card';
import tabsRenderPlugin from './tabs';
import tableEditRenderPlugin from './tableEdit';
import stepsRenderPlugin from './steps';
import remoteComponent from './remoteComponent';

export {
  participantRenderPlugin,
  hyperlinkRenderPlugin,
  cardRenderPlugin,
  collapseRenderPlugin,
  tabsRenderPlugin,
  tableEditRenderPlugin,
  stepsRenderPlugin,
  remoteComponent
};

export default [participantRenderPlugin, hyperlinkRenderPlugin, cardRenderPlugin, collapseRenderPlugin, tabsRenderPlugin, tableEditRenderPlugin, stepsRenderPlugin,remoteComponent];
